import { render, staticRenderFns } from "./LabelScan.vue?vue&type=template&id=3cf7791b&scoped=true&"
import script from "./LabelScan.vue?vue&type=script&lang=js&"
export * from "./LabelScan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf7791b",
  null
  
)

export default component.exports